import React from 'react'
import { Box, Button, Chip, Typography } from '@material-ui/core'
import { Eye as EyeIcon } from 'react-feather'
import clsx from 'clsx'

import constants from 'constants/index'

import TemplatePreview from '../TemplatePreview'
import useStyles from './styles'

const TemplateCard = ({
  template,
  isSelected,
  isReadOnly,
  onSelect,
  onPreview,
  hideActions,
  noBorder,
  noShadow,
  fitContent,
}) => {
  const classes = useStyles()

  const difficultyKey = (template.difficulty || '').toLowerCase()
  const difficulty = constants.phishing.DIFFICULTY_MAP[difficultyKey] || null

  return (
    <Box
      className={clsx(classes.templateCard, {
        [classes.templateCardSelected]: isSelected && !noBorder,
        [classes.templateCardDisabled]: isReadOnly && !noShadow,
        [classes.templateCardNoBorder]: noBorder,
      })}
      style={noShadow ? { boxShadow: 'none', cursor: 'default' } : undefined}
      onClick={() => onSelect(template.id)}
    >
      <TemplatePreview
        html={template.emailHtmlBody}
        title={template.name}
        fitContent={fitContent}
      />

      <Box className={classes.cardFooter}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={0.5}
        >
          <Typography variant="subtitle2" className={classes.templateName}>
            {template.name}
          </Typography>
        </Box>

        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.templateSubject}
        >
          {template.emailSubject}
        </Typography>

        {difficulty && (
          <Box
            display="flex"
            alignItems="center"
            className={classes.difficultyRow}
          >
            <Typography variant="caption" color="textSecondary">
              Dificuldade da campanha:
            </Typography>
            <Chip
              label={difficulty.label}
              size="small"
              className={clsx(
                classes.difficultyChip,
                classes[`difficulty_${difficulty.color}`],
              )}
            />
          </Box>
        )}

        {!hideActions && (
          <Box display="flex" className={classes.cardActions}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<EyeIcon size={13} />}
              className={classes.btnVisualize}
              onClick={(event) => {
                event.stopPropagation()
                onPreview(template)
              }}
              disabled={!template.emailHtmlBody}
            >
              Visualizar
            </Button>
            <Button
              size="small"
              variant={isSelected ? 'contained' : 'outlined'}
              color="primary"
              className={clsx(classes.btnUse, {
                [classes.btnUseSelected]: isSelected,
              })}
              onClick={(event) => {
                event.stopPropagation()
                onSelect(template.id)
              }}
              disabled={isReadOnly}
            >
              {isSelected ? 'Selecionado ✓' : 'Usar este modelo'}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default TemplateCard
